import './_testimonial-panel.scss';
